import type { Deck } from '@/framework/types';
import { slides } from './slides';

const deck: Deck = {
  slug: 'orca-five-lessons',
  category: 'event-talks',
  title: 'Five Lessons from Building an Open Managed Agents Runtime',
  speaker: 'Sijie Guo',
  description:
    'A 10-minute talk on the three problems nobody demos — cost, control, choice — and what building Orca Agent Engine taught us about each.',
  date: '2026-09-30',
  context: 'The AI Conference · San Francisco 2026',
  visibility: 'public',
  slides,
};

export default deck;
